export const removeIndexIfIsArrayIndex = (key, indent) => {
  //this will do that key that contains index array will be unique
  if (!isNaN(Number(key))) {
    return `${indent}__${key}`
  }
  return key
}

export const addIndentIfIsArrayIndex = (key, indent) => {
  if (!isNaN(Number(key))) {
    return `${indent}__${key}`
  }
  return key
}

export const cleanKey = (key) => {
  // from GSD_id to id
  if (typeof key === 'string') {
    const splitKey = key.split('__')
    if (splitKey.length === 1) {
      return splitKey[0]
    }
    return splitKey[1]
  }
}

export const setNewExpandedKeys = (checkedNodes, setCheckedNodes, key) => {
  if (key) {
    let keyIndex = checkedNodes.indexOf(key)
    const newCheckedNodes = [...checkedNodes]
    if (keyIndex > -1) {
      //Splice the array
      let end = newCheckedNodes.length + 1
      newCheckedNodes.splice(keyIndex, end)
      setCheckedNodes(newCheckedNodes)
    } else {
      newCheckedNodes.push(key)
      setCheckedNodes(newCheckedNodes)
    }
  }
}

const findNodePathRecursive = (data, nodesSelected, testData) => {
  /*
        delete the before last item of the array and continue checking, 
        until finding which node it belongs to, if it does not belong to any, it is because it is the parent node     
    */
  if (nodesSelected.length == 1) {
    return undefined
  }
  nodesSelected.splice(nodesSelected.length - 2, 1) // delete last before node of de array and
  nodesSelected.forEach((node, i) => {
    // the information is iterated with the keys that the array has
    if (i === 0) {
      testData = data[isIndexArray(node)]
    }
    if (i >= 1) {
      testData = testData[isIndexArray(node)]
      if (!testData) {
        findNodePathRecursive(data, nodesSelected)
      }
    }
  })
}

export const isIndexArray = (node) => {
  if (!isNaN(Number(cleanKey(node)))) {
    return cleanKey(node)
  }
  return node
}

export const tracesObject = (data, nodesSelected) => {
  // trace of a object
  // check if every node has the node selected
  // ["node1", "subNode1" , "a"]  - Good
  // ["node1", "subNode1" , "b"]  - Bad
  // example {
  //   node1: {
  //     subNode1 : {
  // a : "a"
  //     }
  //     subNode2 : {
  // b : "b"
  //     }
  //  }
  // }
  let auxData = {}
  let testData
  nodesSelected.forEach((node, i) => {
    if (i === 0) {
      auxData = data[isIndexArray(node)]
    }
    if (i >= 1) {
      auxData = auxData[isIndexArray(node)]
      if (!auxData) {
        findNodePathRecursive(data, nodesSelected, testData)
      }
    }
  })
  return auxData
}

export const skipValueFromCheckedBox = (checkedBox) => {
  //example
  // from checkbox =  ['FAA_id:3', 'FAW_type:GMX']
  // to checkbox =  ['FAA_id', 'FAW_type']
  if (checkedBox?.length >= 1) {
    const checkedWithOutValues = [...checkedBox]
    return checkedWithOutValues.map((item) => {
      let key = item.split(':')
      return key[0]
    })
  }
  return checkedBox
}

const splitByDot = (string) => {
  if (typeof string === 'string') {
    return string.split('.')
  }
}

export const cleanPath = (path, cleanArray = false) => {
  if (path) {
    let arrayPath = splitByDot(path)
    return arrayPath.map((item) => {
      let key = cleanKey(item)

      if (cleanArray && key) {
        const index = key.indexOf('[')
        if (index > -1) {
          key = [
            key.substring(0, index),
            parseInt(key.substring(
              index + 1,
              key.lastIndexOf("]")
            ))
          ]
        }
      }

      return key
    })
  }
}
